// src/TrackerSummary.jsx
// Panel header + tally row for the main table panel (.table-container).
// Counts come from the rows of the selected time frame (the /api/status response),
// so they follow the month navigation but not the search / sector / country filters.
import React, { useMemo } from "react";
import "./esf-summary.css";

const statusOf = r => (r.monthly_status || "no_data").toLowerCase();

export default function TrackerSummary({ rows, isLatest, monthLabel }) {
  const { investing, withdrawing } = useMemo(() => {
    // Count distinct companies, in case a company ever appears on two rows.
    const inv = new Set();
    const wd = new Set();
    rows.forEach(r => {
      const s = statusOf(r);
      if (s === "investing") inv.add(r.company);
      else if (s === "withdrawing") wd.add(r.company);
    });
    return { investing: inv.size, withdrawing: wd.size };
  }, [rows]);

  const timeframe = isLatest ? "Last 30 days · Updated daily" : monthLabel;

  return (
    <div className="crt-summary">
      <div className="crt-summary-bar">
        <div className="crt-summary-title">Corporate Response Tracker</div>
        <div className="crt-summary-timeframe">{timeframe}</div>
      </div>
      <div className="crt-summary-tally" aria-live="polite">
        <div className="crt-summary-stat">
          <span className="crt-summary-num crt-summary-num--in">{investing}</span>
          <span className="crt-summary-label">investing</span>
        </div>
        <div className="crt-summary-stat">
          <span className="crt-summary-num crt-summary-num--out">{withdrawing}</span>
          <span className="crt-summary-label">withdrawing</span>
        </div>
        <div className="crt-summary-note">
          Among STOXX Europe 600 companies with a recorded US move
        </div>
      </div>
    </div>
  );
}
